/**
 * The shadow under the picker's floating surfaces: the popup, the info card and a chip's bubble menu.
 *
 * Their 1px outline already separates them from the page, so the shadow only has to lift them: one
 * soft, low layer. MUI's elevation 8 (three dark layers) read as heavy next to the survey editor's
 * own popups, which are outlined only.
 */
export const FLOATING_SHADOW = "0 4px 16px rgba(15, 23, 42, 0.08)";
